import { LoginReason } from "@tv2no/tv2no-snowplow-tracking";

export const isLoginReason = (value: any): value is LoginReason => {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof value.category === 'string' &&
    typeof value.action === 'string'
  );
};
